import { postLogout } from "@/modules/Auth/api/authApi.js";
import loginStore from "@/modules/Auth/store/loginStore.js";
import signupStore from "@/modules/Auth/store/signupStore.js";
import insuredProfileStore from "@/shared/store/insuredProfileStore.js";
import ilfDlfStore from "@/modules/Quote/store/ilfDlfStore.js";
import specialityStore from "@/modules/Quote/store/specialityStore.js";
import sessionStore from "@/shared/store/sessionStore.js";
import modalStore from "@/shared/store/modalStore.js";
import dashboardStore from "@/modules/Dashboard/store/dashboardStore.js";
import profileStore from "@/modules/Profile/store/profileStore.js";
import quoteFormStore from "@/modules/Quote/store/quoteFormStore.js";
import personalStore from "@/modules/Quote/store/personalStore.js";
import classificationStore from "@/modules/Quote/store/classificationStore.js";
import coverageStore from "@/modules/Quote/store/coverageStore.js";
import questionsStore from "@/modules/Quote/store/questionsStore.js";
import submissionStore from "@/modules/Quote/store/submissionStore.js";
import attestStore from "@/modules/Quote/store/attestStore.js";
import paymentOrderStore from "@/modules/Payment/store/paymentOrderStore.js";
import bindStore from "@/modules/Payment/store/bindStore.js";
import stripeStore from "@/modules/Payment/store/stripeStore.js";
import declUploadStore from "@/modules/Payment/store/declUploadStore.js";

/** Reset every quote-flow store. Use when starting a brand-new quote. */
export function resetQuoteFlow() {
  signupStore.clear();
  quoteFormStore.clear();
  personalStore.clear();
  classificationStore.clear();
  coverageStore.clear();
  questionsStore.clear();
  submissionStore.clear();
  attestStore.clear();
  paymentOrderStore.clear();
  bindStore.clear();
  declUploadStore.clear();
  sessionStore.bound = false;
}

/**
 * Full sign-out: POST /logout, clear every store, wipe non-HttpOnly
 * cookies + browser storage so a reload starts from a clean slate.
 */
export async function signOut() {
  try { await postLogout(); } catch { /* still continue */ }
  resetQuoteFlow();
  loginStore.clear();
  dashboardStore.clear();
  profileStore.clear();
  stripeStore.clear();
  modalStore.clear();
  insuredProfileStore.insuredProfile = null;
  sessionStore.clear();
  try {
    document.cookie.split(";").forEach((c) => {
      const name = c.split("=")[0].trim();
      if (name) document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
    localStorage.clear();
    sessionStorage.clear();
  } catch { /* storage may be unavailable */ }
}
